import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { getConversationMessages } from 'api/ai-assistant/ai-assistant-api';

import { AI_ASSISTANT_CONVERSATIONS_KEY } from '../ai-assistant.constants';

interface UseApiGetConversationMessagesArgs {
  oktaUserId: string;
  conversationId: string | null | undefined;
  clientId: string | number;
}

export const useApiGetConversationMessages = ({
  oktaUserId,
  conversationId,
  clientId,
}: UseApiGetConversationMessagesArgs): UseQueryResult<unknown, unknown> =>
  useQuery({
    queryKey: [
      AI_ASSISTANT_CONVERSATIONS_KEY,
      oktaUserId,
      conversationId,
      clientId,
    ],
    queryFn: () =>
      getConversationMessages({
        oktaUserId,
        conversationId: conversationId as string,
        clientId,
      }),
    enabled: !!oktaUserId && !!conversationId && !!clientId,
    staleTime: 0,
  });
